<ion-header>
  <ion-toolbar>
    <ion-title>Emulated Receipt</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">Close</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="emulated-receipt-content">
  <div class="receipt-preview-shell">
    <pre
      class="receipt-paper"
      [style.--receipt-chars]="paperWidthChars"
    >{{ receiptText }}</pre>
  </div>
</ion-content>
